import { NTHFlag } from 'src/app/shared/constants/flag';
import { SocieteLinkedModel } from '../societe-linked.model';
import { BcLineModel } from './bc-line.model';
import { CycleBcModel } from './cycle-bc.model';
import { DefinitionTypeBC } from 'src/app/shared/typeBCDefinitions';

export class BcModel extends SocieteLinkedModel {

    code: string = '*';
    libelle: string ='';
    // codeLib site
    codeSite: string = '';
    libelleSite: string= '';
    // codeLib site de livraison
    codeSiteLivraison: string = '';
    libelleSiteLivraison: string= '';
     // codeLib CA1
    codeCa1: string= '';
    libelleCa1: string = '';
    // codeLib Fournisseur
    codeFourn: string = '';
    libelleFourn: string = '';
    // codeLib condition de reglement
    codeCondRegl: string = '';
    libelleCondRegl: string = '';
    // codeLib Mode de reglement
    codeModeRegl: string = '';
    libelleModeRegl: string = '';
    // codeLib JProvis
    codeJProvis: string = '';
    libelleJProvis: string = '';
    // codeLib CgProvis
    codeCgProvis: string = '';
    libelleCgProvis: string = '';

    status: string = '';
    statusNum: number = 1;
    // N° de bc amont
    bcAmont: string = null;
    // Mention
    mention: string = '';
    commentaires: string = '';
    // référence fournisseur
    refFourn: string = '';
    // Code chantier ( Ancien code AE)
    chantier: string = '';

    // Date du BC
    dBc: Date = new Date(Date.now());
    // date de livraison
    dLivraison: Date = null;
    // date de reglement
    dRegl: Date = new Date(Date.now());
    // Date annulation
    dAnnule: Date = new Date(Date.now());
    // Date provisionnement
    dProvis: Date = new Date(Date.now());
    // Date déprovisionnement
    dDeprovis: Date = new Date(Date.now());

    //BC Enveloppe date de fin de validité
    dFinValid: Date = null;

    // tva obligatoire | 0 par defaut
    tva: number = 0;
    // ht obligatoire | 0 par defaut
    ht: number = 0;
    // ttc obligatoire | 0 par defaut
    ttc: number = 0;

    // Flags avec 3 etats ( 0 | 1 | 2)
    fValide: NTHFlag = NTHFlag.None;
    fFacture: NTHFlag = NTHFlag.None;
    fAnnule: NTHFlag = NTHFlag.None;
    fProvis: NTHFlag = NTHFlag.None;
    fDeprovis: NTHFlag = NTHFlag.None;
    fLivre: NTHFlag = NTHFlag.None;
    fHasBp: NTHFlag = NTHFlag.None; // Si les lignes BC sont liée a un BP ou partiellement ou pas du tout

    // Boolean ( 0 | 1)
    bRetour: boolean = false;
    bBloque: boolean = false;

    type: string = DefinitionTypeBC.BCStandard;

    // liste des bc lignes
    bcLines: BcLineModel[] = [];

    cycleBcs: CycleBcModel[] = [];

    /* Ce champ n'est pas destiné à être enregistré en BDD */
    position: number = 0;
    trigrammeCreateur?: string;
    nomCompletCreateur?: string;
    fLitige: NTHFlag = NTHFlag.None;
}


